import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'setup.integrations.shopify.title' }),
    orderName: translate({ id: 'shopify.orderName' }),
  }))

  return api
}
